export function AcRequiredFields(fields: any[], success: () => void, failure: () => void) {
  for (let i = 0; i < fields.length; i++) {
    if (!fields[i]) {
      failure()
      return
    }
  }
  success()
}
